/**
 * One argument group (pocket > hat > block) in the printed report.
 */

import type { ArgumentGroup } from '../textUtils';
import { ReportCard } from './ReportCard';

export function ReportArgumentGroup({ group }: { group: ArgumentGroup }) {
  return (
    <section className="report-arg">
      <h3 className="report-arg-head">{group.label}</h3>
      {group.summary && <p className="report-arg-summary">{group.summary}</p>}
      {group.chains.length > 0 && (
        <ul className="report-arg-summary" style={{ listStyle: 'disc inside', paddingLeft: 16, marginBottom: 12 }}>
          {group.chains.map((c, i) => (
            <li key={i}>{c}</li>
          ))}
        </ul>
      )}
      {group.cards.map((c) => (
        <ReportCard key={c.id} card={c} />
      ))}
    </section>
  );
}
